import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ICON_BUTTON_TOGGLE_CLASS_NAME = 'IconButtonToggle';
export const ICON_BUTTON_TOGGLE_CLASS_SLOTS = ['root', 'background'] as const;

export type IconButtonToggleClassSlot =
	(typeof ICON_BUTTON_TOGGLE_CLASS_SLOTS)[number];

export interface IconButtonToggleClasses {
	root: string;
	background: string;
	fill: string;
	on: string;
}

export type IconButtonToggleClassKey = keyof IconButtonToggleClasses;

export const getIconButtonToggleUtilityClass = (slot: string) =>
	generateUtilityClass(ICON_BUTTON_TOGGLE_CLASS_NAME, slot);

export const iconButtonToggleClasses: IconButtonToggleClasses =
	generateUtilityClasses(ICON_BUTTON_TOGGLE_CLASS_NAME, [
		'root',
		'background',
		'fill',
		'on',
	]);

export default iconButtonToggleClasses;
